import { createActions } from 'redux-actions';

export const {
  updateSourceInput,
  updateCategoryInput,
  updateCameraInput,
  updateCameraIdInput,
  updateBatchInput,
  updateImageSnInput,
  updateImageSize,
  updateModelInput,
  updateEvaluatedImageFilter,
  disableImageSizeSearch
} = createActions({
  UPDATE_SOURCE_INPUT: input => input,
  UPDATE_CATEGORY_INPUT: input => input,
  UPDATE_CAMERA_INPUT: input => input,
  UPDATE_CAMERA_ID_INPUT: input => input,
  UPDATE_BATCH_INPUT: input => input,
  UPDATE_IMAGE_SN_INPUT: input => input,
  UPDATE_IMAGE_SIZE: input => input,
  UPDATE_MODEL_INPUT: input => input,
  UPDATE_EVALUATED_IMAGE_FILTER: bool => bool,
  DISABLE_IMAGE_SIZE_SEARCH: () => undefined
});



// WEBPACK FOOTER //
// ./src/actions/SearchParameter.Actions.js